// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/fonts/Poppins/fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` body.dark-theme {

   --brandBodyBackgroundColor: #1D242E;
   /* --body-background: #e5e5e5; */
   --brandInputBackgroundColor: #465970;
   /* --input-background: #465970; */
   --dark-color-primary: #edeeef;


   /* darkMode colors and vars */

   --brandPrimaryColor: #93cbff;
   /* --color-primary: #93cbff; */
   --brandSecondaryColor: #ebeff2;
   /* --color-secondary: #ebeff2; */
   --brandTertiaryColor: #b6b6b7;
   /* --color-tertiary: #b6b6b7; */
   --brandBorderActiveColor: #465d7a;
   /* --color-border: #465d7a; */



   --brandPrimaryBackgroundColor: #1d242e;
   --brandSecondaryBackgroundColor: #2b3746;
   --brandTertiaryBackgroundColor: #4b7091;
   --brandInverseBackgroundColor: #FFFFFF;
   --brandQuaternaryBackgroundColor: #1D242E;
   --brandQuinaryBackgroundColor: #93CBEF;


   /* --background-primary-color: #1d242e;
  --background-secondary-color: #2b3746;
  --background-tertiary-color: #4b7091;
  --background-inverse-color: #4b7091; */


   --brandTextPrimaryColor: #ebeff2;
   /* --text-primary-color: #ebeff2; */
   --brandTextSecondaryColor: #e9e9e9;
   /* --text-secondary-color: #e9e9e9; */
   --brandTextTertiaryColor: #bfd7f4;
   /* --text-tertiary-color: #bfd7f4; */
   --brandTextQuaternaryColor: #FFFFFF;
   --brandDefaultQuinaryColor: #93CBEF;
   --brandTextSenaryColor: #1D242E;
   --brandTextSeptenaryColor: #93CBEF;
   --brandTextInverseColor: #ffffff;
   --brandDefaultQuinaryColor: #93CBEF;
   --brandDefaultQuaternaryColor: #465970;
   --brandDefaultSenaryColor: #93CBEF;
   --brandSenaryBackgroundColor: #D3E7FA;
   --brandTextQuinaryColor: #EBEFF2;
   --brandTextSeptenaryColor: #D3E7FA;
   /* --text-inverse-color: #ffffff; */
   --text-default-color: #4d5866;


   --brandGraphPrimaryColor: #638ec6;
   /* --graph-primary-color: #638ec6; */
   --brandGraphSecondaryColor: #c2def8;
   /* --graph-secondary-color: #c2def8; */
   --brandGraphTertiaryColor: #6f889e;
   /* --graph-tertiary-color: #6f889e; */
   --brandGraphQuaternaryColor: #6faee6;
   /* --graph-quaternary-color: #6faee6; */
   --brandGraphQuinaryColor: #5c95c8;
   /* --graph-quinary-color: #5c95c8; */


   --brandBorderPrimaryColor: #c3cbd1;
   /* --border-primary-color: #c3cbd1; */
   --brandBorderActiveColor: #2b3746;
   --brandBorderSecondaryBorderColor: #2b3746;
   /* --border-active-color: #2b3746; */
   --brandErrorColor: #f44336;
   /* --branderror-color: #f44336; */
   --brandDisabledColor: #dbe2e9;
   --brandSuccessColor: #a5e3cd;
   --shadow: rgba(0, 0, 0, .25);


   /* new colors */
   /* background colors */
   --brandPageBackgroundColor: #E8EBF0;
   --brandInverseBackgroundColor: #FFFFFF;
   --brandInformationBackgroundColor: #DBE2E9;
   --brandFieldSelectionBackgroundColor: #E8EBF0;
   --brandNavigationBackgroundColor: #2B3746;
   --brandNavigationFieldSelectionBackgroundColor: #4B7091;

   /* Text colors */
   --brandPrimaryTextColor: #2B3746;
   --brandSecondaryTextColor: #4D5866;
   --brandButtonTextColor: #4B7091;
   --brandInverseTextColor: #FFFFFF;
   --brandNavigationTextColor: #FFFFFF;
   --brandNavigationSelectionTextColor: #93CBEF;
   --brandDisabledTextColor: #4D5866;
   --brandCreditCardTextColor: #FFFFFF;
   --brandSelectedPillTextColor: #FFFFFF;
   --brandUnselectedPillTextColor: #4B7091;

   /* Button colors */
   --brandPrimaryButtonColor: #4B7091;
   --brandTopPageButtonColor: #DBE2E9;

   /* Pill colors */
   --brandUnselectedPillColor: #FFFFFF;
   --brandSelectedPillColor: #4B7091;

   /* Border colors */
   --brandPrimaryBorderColor: #C3CBD1;
   --brandFieldBorderColor: #2B3746;
   --brandActiveBorderColor: #4B7091;
   --brandNavigationBorderColor: #AFBDD1;
   --brandNavigationFieldBorderColor: #FFFFFF;
   --brandUnselectedpPillBorderColor: #4B7091;

   /* Icon colors */
   --brandPrimaryIconColor: #4B7091;
   --brandInverseIconColor: #FFFFFF;
   --brandNavigationIconColor: #FFFFFF;
   --brandNavigation-electionIconColor: #93CBEF;
   --brandNavigationFieldIconColor: #93CBEF;
   --brandSelectedPillIconColor: #FFFFFF;
   --brandUnselectedPillIconColor: #4B7091;

   /* State colors */
   --brandDefaultStateColor: #2B3746;
   --brandErrorStateColor: #B31E14;
   --brandSuccessStateColor: #008858;
   --brandDisabledStateColor: #C3CBD1;
   --brandHoverStateColor: #2B3746;

   /* Graph colors */
   --brandGraphPrimaryColor: #2276c0;
   --brandGraphSecondaryColor: #144380;
   --brandGraphTertiaryColor: #002342;
   --brandGraphQuaternaryColor: #385671;
   --brandGraphQuinaryColor: #5c95c8;
   --brandGraphSenaryColor: #93CBEF;

   /* Login page colors */
   /* Background colors */
   --brandLoginPageBackgroundColor: #1D242E;
   --brandLoginFieldBackgroundColor: #465970;
   --brandLoginFieldSelectionBackgroundColor: #2E3C50;

   /* Text colors */
   --brandLoginPrimaryTextColor: #FFFFFF;
   --brandLoginFieldTextColor: #FFFFFF;
   --brandLoginButtonTextColor: #1D242E;
   --brandLoginFooterBarTextColor: #1D242E;

   /* Button colors */
   --brandLoginPrimaryButtonColor: #93CBEF;
   --brandLoginHoverButtonColor: #D3E7FA;

   /* Border colors */
   --brandLoginFieldBorderColor: #EBEFF2;

   /* Icon colors */
   --brandLoginFieldIconColor: #FFFFFF;

   /* State colors */
   --brandLoginErrorStateColor: #FF738C;

   /* Footer colors */
   --brandLoginOutsideFooterBarColor: #93CBFF;
   --brandLoginInsideFooterBarColor: #D3E7FA;
 }

 body.light-theme {
   --brandBodyBackgroundColor: #e5e5e5;
   --brandInputBackgroundColor: #465970;
   --brandSecondaryInputBackgroundColor: #465970;

   --brandPrimaryColor: #4b7091;
   --brandSecondaryColor: #2b3746;
   --brandTertiaryColor: #b6b6b7;
   --brandBorderActiveColor: #465d7a;

   --brandPrimaryBackgroundColor: #e8ebf0;
   --brandSecondaryBackgroundColor: #ffffff;
   --brandTertiaryBackgroundColor: #1d242e;
   --brandInverseBackgroundColor: #FFFFFF;
   --brandQuaternaryBackgroundColor: #1D242E;
   --brandQuinaryBackgroundColor: #93CBEF;
   --brandSenaryBackgroundColor: #D3E7FA;

   --brandTextPrimaryColor: #2b3746;
   --brandTextSecondaryColor: #4d5866;
   --brandTextTertiaryColor: #646b76;
   --brandTextInverseColor: #ffffff;
   --text-default-color: #4d5866;

   --brandTextQuaternaryColor: #FFFFFF;
   --brandTextQuinaryColor: #EBEFF2;
   --brandDefaultQuinaryColor: #93CBEF;
   --brandTextSenaryColor: #1D242E;
   --brandTextSeptenaryColor: #93CBEF;
   --brandDefaultQuaternaryColor: #465970;
   --brandSenaryBackgroundColor: #D3E7FA;
   --brandTextSeptenaryColor: #D3E7FA;
   --brandDefaultSenaryColor: #93CBEF;


   /* --brandGraphPrimaryColor:#2276c0; 
  --brandGraphSecondaryColor: #144380;
  --brandGraphTertiaryColor: #002342;
  --brandGraphQuaternaryColor: #385671;
  --brandGraphQuinaryColor:#5c95c8; */

   --brandBorderPrimaryColor: #c3cbd1;
   --brandBorderActiveColor: #4B7091;
   --brandBorderSecondaryBorderColor: #93CBFF;
   --brandDisabledColor: #dbe2e9;
   --brandErrorColor: #f44336;
   --brandSuccessColor: #008858;
   /* lightMode colors 
  --body-background: #e5e5e5;
  --input-background: #465970;

  --primary-color: #4b7091;
  --secondary-color: #2b3746;
  --secondary-color: #2b3746;

  --background-primary-color: #e8ebf0;
  --background-secondary-color: #ffffff;
  --background-tertiary-color: #1d242e;
  --background-inverse-color: #2b3746;
  
  --text-primary-color: #2b3746;
  --text-secondary-color: #4d5866;
  --text-tertiary-color: #646b76;
  --text-inverse-color: #ffffff;
  --text-default-color: #4d5866;

  --graph-primary-color: #2276c0;
  --graph-secondary-color: #144380;
  --graph-tertiary-color: #002342;
  --graph-quaternary-color: #385671;
  --graph-quinary-color: #5c95c8;

  --border-primary-color: #c3cbd1;
  --border-active-color: #4B7091;
  --branddisabled-color: #dbe2e9; */

   /* --branderror-color: #f44336;
  --brandsuccessful-color: #008858; */

   --forest-green-color: #228b22;
   --midnight-blue-color: #191970;
   --mediumorchid--color: #ba55d3;
   --ligh-mode--box-shadow-color: #0000000f;
   --brandselected-list-box-color: #00000014;
   --button-disable-color: #d3d3d3;
   --shadow: rgba(0, 0, 0, .25);
   --brandselected-file-color: #E8EBF0;



   /* new colors */
   /* background colors */
   --brandPageBackgroundColor: #E8EBF0;
   --brandInverseBackgroundColor: #FFFFFF;
   --brandInformationBackgroundColor: #DBE2E9;
   --brandField-selectionBackgroundColor: #E8EBF0;
   --brandNavigationBackgroundColor: #2B3746;
   --brandNavigationFieldSelectionBackgroundColor: #4B7091;

   /* Text colors */
   --brandPrimaryTextColor: #2B3746;
   --brandSecondaryTextColor: #4D5866;
   --brandButtonTextColor: #4B7091;
   --brandInverseTextColor: #FFFFFF;
   --brandNavigationTextColor: #FFFFFF;
   --brandNavigationSelectionTextColor: #93CBEF;
   --brandDisabledTextColor: #4D5866;
   --brandCreditCardTextColor: #FFFFFF;
   --brandSelectedPillTextColor: #FFFFFF;
   --brandUnselectedPillTextColor: #4B7091;

   /* Button colors */
   --brandPrimaryButtonColor: #4B7091;
   --brandTopPageButtonColor: #DBE2E9;

   /* Pill colors */
   --brandUnselectedPillColor: #FFFFFF;
   --brandSelectedPillColor: #4B7091;

   /* Border colors */
   --brandPrimaryBorderColor: #C3CBD1;
   --brandFieldBorderColor: #2B3746;
   --brandActiveBorderColor: #4B7091;
   --brandNavigationBorderColor: #AFBDD1;
   --brandNavigationFieldBorderColor: #FFFFFF;
   --brandUnselectedpPillBorderColor: #4B7091;

   /* Icon colors */
   --brandPrimaryIconColor: #4B7091;
   --brandInverseIconColor: #FFFFFF;
   --brandNavigationIconColor: #FFFFFF;
   --brandNavigationSelectionIconColor: #93CBEF;
   --brandNavigationFieldIconColor: #93CBEF;
   --brandSelectedPillIconColor: #FFFFFF;
   --brandUnselectedPillIconColor: #4B7091;

   /* State colors */
   --brandDefaultStateColor: #2B3746;
   --brandErrorStateColor: #B31E14;
   --brandSuccessStateColor: #008858;
   --brandDisabledStateColor: #C3CBD1;
   --brandHoverStateColor: #2B3746;

   /* Graph colors */
   --brandGraphPrimaryColor: #2276c0;
   --brandGraphSecondaryColor: #144380;
   --brandGraphTertiaryColor: #002342;
   --brandGraphQuaternaryColor: #385671;
   --brandGraphQuinaryColor: #5c95c8;
   --brandGraphSenaryColor: #93CBEF;

   /* Login page colors */
   /* Background colors */
   --brandLoginPageBackgroundColor: #1D242E;
   --brandLoginFieldBackgroundColor: #465970;
   --brandLoginFieldSelectionBackgroundColor: #2E3C50;

   /* Text colors */
   --brandLoginPrimaryTextColor: #FFFFFF;
   --brandLoginFieldTextColor: #FFFFFF;
   --brandLoginButtonTextColor: #1D242E;
   --brandLoginFooterBarTextColor: #1D242E;

   /* Button colors */
   --brandLoginPrimaryButtonColor: #93CBEF;
   --brandLoginHoverButtonColor: #D3E7FA;

   /* Border colors */
   --brandLoginFieldBorderColor: #EBEFF2;

   /* Icon colors */
   --brandLoginFieldIconColor: #FFFFFF;

   /* State colors */
   --brandLoginErrorStateColor: #FF738C;

   /* Footer colors */
   --brandLoginOutsideFooterBarColor: #93CBFF;
   --brandLoginInsideFooterBarColor: #D3E7FA;

 }

 * {
   margin: 0;
   padding: 0;
   box-sizing: border-box;
   /* overflow: hidden; */
   --webkit-overflow: hidden;
 }

 html,
 body {
   font-size: 1em;
   font-style: normal;
  overflow-x: hidden;
  overflow-y: auto;
   
 }

 #root {
   height: 100%;
   opacity: 0;
 }

 #root.show {
   transition: opacity .25s ease-in;
   opacity: 1;
 }

 #page-loader {
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   z-index: -1;
 }

 #page-loader.hide {
   display: none;
 }

 #page-loader img {
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translateX(-50%) translateY(-50%);

 }

 #page-loader>#page-loader-image.hide {
   visibility: hidden;
 }

 /* =======================react date picker================== */

 .date-picked {
   background: var(--text-inverse-color);
   border: 2px solid var(--primary-color);
   box-sizing: border-box;
   border-radius: 6px;
   width: 78%;
   height: 40px;
   z-index: 1;
   position: absolute;
   position: relative;
   display: flex;
   flex-direction: row;
   justify-items: center;
   justify-content: space-between;
   align-items: center;
   padding: 0px 4px 0px 4px;
   margin-left: 0px !important;
   margin-bottom: 6px;
 }

 .rdrDefinedRangesWrapper {
   display: none !important;
 }

 .rdrDateDisplayWrapper {
   width: 85%;
 }

 .rdrDateDisplayWrapper {
   background-color: transparent !important;
 }

 .rdrMonths.rdrMonthsHorizontal {
   border: 2px solid var(--primary-color) !important;
   border-top: none !important;
 }

 .rdrMonthAndYearWrapper {
   border: 2px solid var(--primary-color) !important;
   border-bottom: none !important;
 }

 .DateRangePicker-container {
   border-radius: 6px;
 }

 .rdrCalendarWrapper {
   border-radius: 10px;
 }

 .rdrCalendarWrapper {
   border-right: 8px;
 }

 .rdrStartEdge.rdrEndEdge {
   background: var(--primary-color);
   color: var(--input-background) !important;
 }

 .rdrDayToday .rdrDayNumber span:after,
 .rdrStartEdge,
 .rdrEndEdge {
   background: var(--primary-color) !important;
 }

 .rdrDayEndPreview {
   border: 2px solid var(--primary-color) !important;
 }

 .rdrStartEdge+.rdrDayNumber span,
 .rdrEndEdge+.rdrDayNumber span {
   color: var(--text-inverse-color) !important;
 }

 .rdrInRange {
   background: var(--background-primary-color) !important;
 }

 .rdrDayNumber span {
   color: var(--secondary-color) !important;
   font-weight: 600;
   font-size: 12px;
   line-height: 18px;
 }

 .rdrDayDisabled>.rdrDayNumber span {
   color: var(--background-primary-color) !important;
 }

 .rdrWeekDay,
 .rdrMonthName {
   font-weight: 600 !important;
   font-size: 14px;
   line-height: 18px;
   text-align: center;
   color: var(--primary-color) !important;
 }

 .rdrDayPassive {
   visibility: hidden !important;
 }

 .submit-btn {
   width: 82px;
   height: 42px;
   background: var(--primary-color);
   border-radius: 2px;
   border-style: none;
   outline: none;
   cursor: pointer;
   font-family: 'Poppins', sans-serif;
   font-style: normal;
   font-weight: 600;
   font-size: 14px;
   line-height: 18px;
   color: var(--text-inverse-color);
 }

 .submit-btn:hover {
   background: var(--secondary-color);
 }

 .submit-btn:disabled {
   background-color: var(--background-primary-color);
   color: var(--border-primary-color);
   cursor: not-allowed;
 }

 .react-pdf__Page__svg {
   background-color: transparent !important;
 }

 .rdrDateDisplayItemActive,
 .rdrDateDisplayItem {
   border-color: var(--primary-color) !important;
   border-width: 2px !important;
   height: 50px;
   display: flex !important;
   align-items: center !important;
 }

 .rdrDateDisplayItem input,
 .rdrDateDisplayItemActive input {
   font-family: 'Poppins', sans-serif !important;
   color: var(--text-default-color) !important;
 }

 .rdrDateDisplay {
   margin-left: 0px !important;
 }

 .btn-container {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   position: absolute;
   z-index: 2;
   margin-left: 85%;
   margin-top: 28px;
 }

 .main-container {
   position: 'relative';
 }

 .DateRangePicker-container.error .rdrDateDisplayWrapper .rdrDateDisplay .rdrDateDisplayItem {
   border: 2px solid var(--branderror-color) !important;
 }

 @media (max-width: 1430px) {

   .main-container>.rdrDateRangePickerWrapper,
   .main-container {
     display: flex !important;
     justify-content: center !important;
     flex-direction: column !important;
     align-items: center !important;
   }

   .btn-container {
     position: unset;
     margin-left: 0px;
     margin-bottom: 14px;
   }

   .submit-btn {
     width: 100%;
     padding: 7px 150px;
   }

   .rdrMonths.rdrMonthsVertical {
     border: 2px solid var(--primary-color) !important;
     border-top: none !important;
   }

   .rdrDateDisplayWrapper {
     width: 100%;
   }

   .calendar-labels-wrapper {
     width: 80%;
     display: flex;
     gap: 7%;
   }
 }

 .rdrMonthsVertical {
   border: 2px solid var(--primary-color) !important;
 }

 .labels-container {
   display: flex;
   flex-direction: column;
 }

 .labels-container>p {
   color: var(--brandLoginErrorStateColor);
 }

 .MuiPickersBasePicker-container .MuiPickersToolbar-toolbar,
 .MuiPickersCalendar-week .MuiPickersDay-daySelected,
 .MuiPickersCalendar-week .MuiPickersDay-daySelected:hover {
   background-color: var(--brandPrimaryButtonColor);
   font-family: 'Poppins', sans-serif;
   color: var(--brandInverseTextColor);
 }

 .MuiPickersDay-daySelected .MuiTypography-body2,
 .MuiPickersCalendarHeader-daysHeader .MuiTypography-caption,
 .MuiPickersCalendarHeader-switchHeader .MuiPickersSlideTransition-transitionContainer .MuiTypography-body1, .MuiButtonBase-root {
   font-family: 'Poppins', sans-serif;
 }

 .MuiButton-label .MuiPickersToolbarText-toolbarBtnSelected {
   /* font-family: 'Poppins'; */
   color: var(--brandPrimaryTextColor);
 }

 .calendar-labels-wrapper {
   display: flex;
   margin-bottom: -2px;
 }

 .calendar-labels {
   width: 41%;
   padding: 0 0 0 8px;
   font-size: 0.8em;
   font-weight: 400;
   color: var(--brandPrimaryTextColor);
 }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"CAEC;;GAEE,mCAAmC;GACnC,gCAAgC;GAChC,oCAAoC;GACpC,iCAAiC;GACjC,6BAA6B;;;GAG7B,6BAA6B;;GAE7B,4BAA4B;GAC5B,8BAA8B;GAC9B,8BAA8B;GAC9B,gCAAgC;GAChC,6BAA6B;GAC7B,+BAA+B;GAC/B,iCAAiC;GACjC,6BAA6B;;;;GAI7B,sCAAsC;GACtC,wCAAwC;GACxC,uCAAuC;GACvC,sCAAsC;GACtC,yCAAyC;GACzC,sCAAsC;;;GAGtC;;;wCAGqC;;;GAGrC,gCAAgC;GAChC,mCAAmC;GACnC,kCAAkC;GAClC,qCAAqC;GACrC,iCAAiC;GACjC,oCAAoC;GACpC,mCAAmC;GACnC,mCAAmC;GACnC,+BAA+B;GAC/B,kCAAkC;GAClC,gCAAgC;GAChC,mCAAmC;GACnC,sCAAsC;GACtC,kCAAkC;GAClC,qCAAqC;GACrC,gCAAgC;GAChC,kCAAkC;GAClC,mCAAmC;GACnC,6BAA6B;;;GAG7B,iCAAiC;GACjC,oCAAoC;GACpC,mCAAmC;GACnC,sCAAsC;GACtC,kCAAkC;GAClC,qCAAqC;GACrC,oCAAoC;GACpC,uCAAuC;GACvC,iCAAiC;GACjC,oCAAoC;;;GAGpC,kCAAkC;GAClC,qCAAqC;GACrC,iCAAiC;GACjC,0CAA0C;GAC1C,oCAAoC;GACpC,0BAA0B;GAC1B,iCAAiC;GACjC,6BAA6B;GAC7B,4BAA4B;GAC5B,4BAA4B;;;GAG5B,eAAe;GACf,sBAAsB;GACtB,mCAAmC;GACnC,sCAAsC;GACtC,0CAA0C;GAC1C,6CAA6C;GAC7C,yCAAyC;GACzC,uDAAuD;;GAEvD,gBAAgB;GAChB,gCAAgC;GAChC,kCAAkC;GAClC,+BAA+B;GAC/B,gCAAgC;GAChC,mCAAmC;GACnC,4CAA4C;GAC5C,iCAAiC;GACjC,mCAAmC;GACnC,qCAAqC;GACrC,uCAAuC;;GAEvC,kBAAkB;GAClB,kCAAkC;GAClC,kCAAkC;;GAElC,gBAAgB;GAChB,mCAAmC;GACnC,iCAAiC;;GAEjC,kBAAkB;GAClB,kCAAkC;GAClC,gCAAgC;GAChC,iCAAiC;GACjC,qCAAqC;GACrC,0CAA0C;GAC1C,0CAA0C;;GAE1C,gBAAgB;GAChB,gCAAgC;GAChC,gCAAgC;GAChC,mCAAmC;GACnC,4CAA4C;GAC5C,wCAAwC;GACxC,qCAAqC;GACrC,uCAAuC;;GAEvC,iBAAiB;GACjB,iCAAiC;GACjC,+BAA+B;GAC/B,iCAAiC;GACjC,kCAAkC;GAClC,+BAA+B;;GAE/B,iBAAiB;GACjB,iCAAiC;GACjC,mCAAmC;GACnC,kCAAkC;GAClC,oCAAoC;GACpC,iCAAiC;GACjC,gCAAgC;;GAEhC,sBAAsB;GACtB,sBAAsB;GACtB,wCAAwC;GACxC,yCAAyC;GACzC,kDAAkD;;GAElD,gBAAgB;GAChB,qCAAqC;GACrC,mCAAmC;GACnC,oCAAoC;GACpC,uCAAuC;;GAEvC,kBAAkB;GAClB,uCAAuC;GACvC,qCAAqC;;GAErC,kBAAkB;GAClB,qCAAqC;;GAErC,gBAAgB;GAChB,mCAAmC;;GAEnC,iBAAiB;GACjB,oCAAoC;;GAEpC,kBAAkB;GAClB,0CAA0C;GAC1C,yCAAyC;CAC3C;;CAEA;GACE,mCAAmC;GACnC,oCAAoC;GACpC,6CAA6C;;GAE7C,4BAA4B;GAC5B,8BAA8B;GAC9B,6BAA6B;GAC7B,iCAAiC;;GAEjC,sCAAsC;GACtC,wCAAwC;GACxC,uCAAuC;GACvC,sCAAsC;GACtC,yCAAyC;GACzC,sCAAsC;GACtC,qCAAqC;;GAErC,gCAAgC;GAChC,kCAAkC;GAClC,iCAAiC;GACjC,gCAAgC;GAChC,6BAA6B;;GAE7B,mCAAmC;GACnC,gCAAgC;GAChC,mCAAmC;GACnC,+BAA+B;GAC/B,kCAAkC;GAClC,sCAAsC;GACtC,qCAAqC;GACrC,kCAAkC;GAClC,kCAAkC;;;GAGlC;;;;qCAIkC;;GAElC,kCAAkC;GAClC,iCAAiC;GACjC,0CAA0C;GAC1C,6BAA6B;GAC7B,0BAA0B;GAC1B,4BAA4B;GAC5B;;;;;;;;;;;;;;;;;;;;;;;;;;;mCA2BgC;;GAEhC;qCACkC;;GAElC,6BAA6B;GAC7B,8BAA8B;GAC9B,8BAA8B;GAC9B,wCAAwC;GACxC,yCAAyC;GACzC,+BAA+B;GAC/B,4BAA4B;GAC5B,mCAAmC;;;;GAInC,eAAe;GACf,sBAAsB;GACtB,mCAAmC;GACnC,sCAAsC;GACtC,0CAA0C;GAC1C,8CAA8C;GAC9C,yCAAyC;GACzC,uDAAuD;;GAEvD,gBAAgB;GAChB,gCAAgC;GAChC,kCAAkC;GAClC,+BAA+B;GAC/B,gCAAgC;GAChC,mCAAmC;GACnC,4CAA4C;GAC5C,iCAAiC;GACjC,mCAAmC;GACnC,qCAAqC;GACrC,uCAAuC;;GAEvC,kBAAkB;GAClB,kCAAkC;GAClC,kCAAkC;;GAElC,gBAAgB;GAChB,mCAAmC;GACnC,iCAAiC;;GAEjC,kBAAkB;GAClB,kCAAkC;GAClC,gCAAgC;GAChC,iCAAiC;GACjC,qCAAqC;GACrC,0CAA0C;GAC1C,0CAA0C;;GAE1C,gBAAgB;GAChB,gCAAgC;GAChC,gCAAgC;GAChC,mCAAmC;GACnC,4CAA4C;GAC5C,wCAAwC;GACxC,qCAAqC;GACrC,uCAAuC;;GAEvC,iBAAiB;GACjB,iCAAiC;GACjC,+BAA+B;GAC/B,iCAAiC;GACjC,kCAAkC;GAClC,+BAA+B;;GAE/B,iBAAiB;GACjB,iCAAiC;GACjC,mCAAmC;GACnC,kCAAkC;GAClC,oCAAoC;GACpC,iCAAiC;GACjC,gCAAgC;;GAEhC,sBAAsB;GACtB,sBAAsB;GACtB,wCAAwC;GACxC,yCAAyC;GACzC,kDAAkD;;GAElD,gBAAgB;GAChB,qCAAqC;GACrC,mCAAmC;GACnC,oCAAoC;GACpC,uCAAuC;;GAEvC,kBAAkB;GAClB,uCAAuC;GACvC,qCAAqC;;GAErC,kBAAkB;GAClB,qCAAqC;;GAErC,gBAAgB;GAChB,mCAAmC;;GAEnC,iBAAiB;GACjB,oCAAoC;;GAEpC,kBAAkB;GAClB,0CAA0C;GAC1C,yCAAyC;;CAE3C;;CAEA;GACE,SAAS;GACT,UAAU;GACV,sBAAsB;GACtB,sBAAsB;GACtB,yBAAyB;CAC3B;;CAEA;;GAEE,cAAc;GACd,kBAAkB;EACnB,kBAAkB;EAClB,gBAAgB;;CAEjB;;CAEA;GACE,YAAY;GACZ,UAAU;CACZ;;CAEA;GACE,gCAAgC;GAChC,UAAU;CACZ;;CAEA;GACE,kBAAkB;GAClB,MAAM;GACN,OAAO;GACP,WAAW;GACX,YAAY;GACZ,WAAW;CACb;;CAEA;GACE,aAAa;CACf;;CAEA;GACE,kBAAkB;GAClB,QAAQ;GACR,SAAS;GACT,4CAA4C;;CAE9C;;CAEA;GACE,kBAAkB;CACpB;;CAEA,+DAA+D;;CAE/D;GACE,qCAAqC;GACrC,sCAAsC;GACtC,sBAAsB;GACtB,kBAAkB;GAClB,UAAU;GACV,YAAY;GACZ,UAAU;GACV,kBAAkB;GAClB,kBAAkB;GAClB,aAAa;GACb,mBAAmB;GACnB,qBAAqB;GACrB,8BAA8B;GAC9B,mBAAmB;GACnB,wBAAwB;GACxB,2BAA2B;GAC3B,kBAAkB;CACpB;;CAEA;GACE,wBAAwB;CAC1B;;CAEA;GACE,UAAU;CACZ;;CAEA;GACE,wCAAwC;CAC1C;;CAEA;GACE,iDAAiD;GACjD,2BAA2B;CAC7B;;CAEA;GACE,iDAAiD;GACjD,8BAA8B;CAChC;;CAEA;GACE,kBAAkB;CACpB;;CAEA;GACE,mBAAmB;CACrB;;CAEA;GACE,iBAAiB;CACnB;;CAEA;GACE,gCAAgC;GAChC,yCAAyC;CAC3C;;CAEA;;;GAGE,2CAA2C;CAC7C;;CAEA;GACE,iDAAiD;CACnD;;CAEA;;GAEE,2CAA2C;CAC7C;;CAEA;GACE,sDAAsD;CACxD;;CAEA;GACE,wCAAwC;GACxC,gBAAgB;GAChB,eAAe;GACf,iBAAiB;CACnB;;CAEA;GACE,iDAAiD;CACnD;;CAEA;;GAEE,2BAA2B;GAC3B,eAAe;GACf,iBAAiB;GACjB,kBAAkB;GAClB,sCAAsC;CACxC;;CAEA;GACE,6BAA6B;CAC/B;;CAEA;GACE,WAAW;GACX,YAAY;GACZ,gCAAgC;GAChC,kBAAkB;GAClB,kBAAkB;GAClB,aAAa;GACb,eAAe;GACf,kCAAkC;GAClC,kBAAkB;GAClB,gBAAgB;GAChB,eAAe;GACf,iBAAiB;GACjB,gCAAgC;CAClC;;CAEA;GACE,kCAAkC;CACpC;;CAEA;GACE,iDAAiD;GACjD,kCAAkC;GAClC,mBAAmB;CACrB;;CAEA;GACE,wCAAwC;CAC1C;;CAEA;;GAEE,6CAA6C;GAC7C,4BAA4B;GAC5B,YAAY;GACZ,wBAAwB;GACxB,8BAA8B;CAChC;;CAEA;;GAEE,6CAA6C;GAC7C,2CAA2C;CAC7C;;CAEA;GACE,2BAA2B;CAC7B;;CAEA;GACE,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,kBAAkB;GAClB,UAAU;GACV,gBAAgB;GAChB,gBAAgB;CAClB;;CAEA;GACE,oBAAoB;CACtB;;CAEA;GACE,oDAAoD;CACtD;;CAEA;;GAEE;;KAEE,wBAAwB;KACxB,kCAAkC;KAClC,iCAAiC;KACjC,8BAA8B;GAChC;;GAEA;KACE,eAAe;KACf,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;KACE,WAAW;KACX,kBAAkB;GACpB;;GAEA;KACE,iDAAiD;KACjD,2BAA2B;GAC7B;;GAEA;KACE,WAAW;GACb;;GAEA;KACE,UAAU;KACV,aAAa;KACb,OAAO;GACT;CACF;;CAEA;GACE,iDAAiD;CACnD;;CAEA;GACE,aAAa;GACb,sBAAsB;CACxB;;CAEA;GACE,uCAAuC;CACzC;;CAEA;;;GAGE,gDAAgD;GAChD,kCAAkC;GAClC,mCAAmC;CACrC;;CAEA;;;GAGE,kCAAkC;CACpC;;CAEA;GACE,4BAA4B;GAC5B,mCAAmC;CACrC;;CAEA;GACE,aAAa;GACb,mBAAmB;CACrB;;CAEA;GACE,UAAU;GACV,kBAAkB;GAClB,gBAAgB;GAChB,gBAAgB;GAChB,mCAAmC;CACrC","sourcesContent":[" @import './assets/fonts/Poppins/fonts.css';\n\n body.dark-theme {\n\n   --brandBodyBackgroundColor: #1D242E;\n   /* --body-background: #e5e5e5; */\n   --brandInputBackgroundColor: #465970;\n   /* --input-background: #465970; */\n   --dark-color-primary: #edeeef;\n\n\n   /* darkMode colors and vars */\n\n   --brandPrimaryColor: #93cbff;\n   /* --color-primary: #93cbff; */\n   --brandSecondaryColor: #ebeff2;\n   /* --color-secondary: #ebeff2; */\n   --brandTertiaryColor: #b6b6b7;\n   /* --color-tertiary: #b6b6b7; */\n   --brandBorderActiveColor: #465d7a;\n   /* --color-border: #465d7a; */\n\n\n\n   --brandPrimaryBackgroundColor: #1d242e;\n   --brandSecondaryBackgroundColor: #2b3746;\n   --brandTertiaryBackgroundColor: #4b7091;\n   --brandInverseBackgroundColor: #FFFFFF;\n   --brandQuaternaryBackgroundColor: #1D242E;\n   --brandQuinaryBackgroundColor: #93CBEF;\n\n\n   /* --background-primary-color: #1d242e;\n  --background-secondary-color: #2b3746;\n  --background-tertiary-color: #4b7091;\n  --background-inverse-color: #4b7091; */\n\n\n   --brandTextPrimaryColor: #ebeff2;\n   /* --text-primary-color: #ebeff2; */\n   --brandTextSecondaryColor: #e9e9e9;\n   /* --text-secondary-color: #e9e9e9; */\n   --brandTextTertiaryColor: #bfd7f4;\n   /* --text-tertiary-color: #bfd7f4; */\n   --brandTextQuaternaryColor: #FFFFFF;\n   --brandDefaultQuinaryColor: #93CBEF;\n   --brandTextSenaryColor: #1D242E;\n   --brandTextSeptenaryColor: #93CBEF;\n   --brandTextInverseColor: #ffffff;\n   --brandDefaultQuinaryColor: #93CBEF;\n   --brandDefaultQuaternaryColor: #465970;\n   --brandDefaultSenaryColor: #93CBEF;\n   --brandSenaryBackgroundColor: #D3E7FA;\n   --brandTextQuinaryColor: #EBEFF2;\n   --brandTextSeptenaryColor: #D3E7FA;\n   /* --text-inverse-color: #ffffff; */\n   --text-default-color: #4d5866;\n\n\n   --brandGraphPrimaryColor: #638ec6;\n   /* --graph-primary-color: #638ec6; */\n   --brandGraphSecondaryColor: #c2def8;\n   /* --graph-secondary-color: #c2def8; */\n   --brandGraphTertiaryColor: #6f889e;\n   /* --graph-tertiary-color: #6f889e; */\n   --brandGraphQuaternaryColor: #6faee6;\n   /* --graph-quaternary-color: #6faee6; */\n   --brandGraphQuinaryColor: #5c95c8;\n   /* --graph-quinary-color: #5c95c8; */\n\n\n   --brandBorderPrimaryColor: #c3cbd1;\n   /* --border-primary-color: #c3cbd1; */\n   --brandBorderActiveColor: #2b3746;\n   --brandBorderSecondaryBorderColor: #2b3746;\n   /* --border-active-color: #2b3746; */\n   --brandErrorColor: #f44336;\n   /* --branderror-color: #f44336; */\n   --brandDisabledColor: #dbe2e9;\n   --brandSuccessColor: #a5e3cd;\n   --shadow: rgba(0, 0, 0, .25);\n\n\n   /* new colors */\n   /* background colors */\n   --brandPageBackgroundColor: #E8EBF0;\n   --brandInverseBackgroundColor: #FFFFFF;\n   --brandInformationBackgroundColor: #DBE2E9;\n   --brandFieldSelectionBackgroundColor: #E8EBF0;\n   --brandNavigationBackgroundColor: #2B3746;\n   --brandNavigationFieldSelectionBackgroundColor: #4B7091;\n\n   /* Text colors */\n   --brandPrimaryTextColor: #2B3746;\n   --brandSecondaryTextColor: #4D5866;\n   --brandButtonTextColor: #4B7091;\n   --brandInverseTextColor: #FFFFFF;\n   --brandNavigationTextColor: #FFFFFF;\n   --brandNavigationSelectionTextColor: #93CBEF;\n   --brandDisabledTextColor: #4D5866;\n   --brandCreditCardTextColor: #FFFFFF;\n   --brandSelectedPillTextColor: #FFFFFF;\n   --brandUnselectedPillTextColor: #4B7091;\n\n   /* Button colors */\n   --brandPrimaryButtonColor: #4B7091;\n   --brandTopPageButtonColor: #DBE2E9;\n\n   /* Pill colors */\n   --brandUnselectedPillColor: #FFFFFF;\n   --brandSelectedPillColor: #4B7091;\n\n   /* Border colors */\n   --brandPrimaryBorderColor: #C3CBD1;\n   --brandFieldBorderColor: #2B3746;\n   --brandActiveBorderColor: #4B7091;\n   --brandNavigationBorderColor: #AFBDD1;\n   --brandNavigationFieldBorderColor: #FFFFFF;\n   --brandUnselectedpPillBorderColor: #4B7091;\n\n   /* Icon colors */\n   --brandPrimaryIconColor: #4B7091;\n   --brandInverseIconColor: #FFFFFF;\n   --brandNavigationIconColor: #FFFFFF;\n   --brandNavigation-electionIconColor: #93CBEF;\n   --brandNavigationFieldIconColor: #93CBEF;\n   --brandSelectedPillIconColor: #FFFFFF;\n   --brandUnselectedPillIconColor: #4B7091;\n\n   /* State colors */\n   --brandDefaultStateColor: #2B3746;\n   --brandErrorStateColor: #B31E14;\n   --brandSuccessStateColor: #008858;\n   --brandDisabledStateColor: #C3CBD1;\n   --brandHoverStateColor: #2B3746;\n\n   /* Graph colors */\n   --brandGraphPrimaryColor: #2276c0;\n   --brandGraphSecondaryColor: #144380;\n   --brandGraphTertiaryColor: #002342;\n   --brandGraphQuaternaryColor: #385671;\n   --brandGraphQuinaryColor: #5c95c8;\n   --brandGraphSenaryColor: #93CBEF;\n\n   /* Login page colors */\n   /* Background colors */\n   --brandLoginPageBackgroundColor: #1D242E;\n   --brandLoginFieldBackgroundColor: #465970;\n   --brandLoginFieldSelectionBackgroundColor: #2E3C50;\n\n   /* Text colors */\n   --brandLoginPrimaryTextColor: #FFFFFF;\n   --brandLoginFieldTextColor: #FFFFFF;\n   --brandLoginButtonTextColor: #1D242E;\n   --brandLoginFooterBarTextColor: #1D242E;\n\n   /* Button colors */\n   --brandLoginPrimaryButtonColor: #93CBEF;\n   --brandLoginHoverButtonColor: #D3E7FA;\n\n   /* Border colors */\n   --brandLoginFieldBorderColor: #EBEFF2;\n\n   /* Icon colors */\n   --brandLoginFieldIconColor: #FFFFFF;\n\n   /* State colors */\n   --brandLoginErrorStateColor: #FF738C;\n\n   /* Footer colors */\n   --brandLoginOutsideFooterBarColor: #93CBFF;\n   --brandLoginInsideFooterBarColor: #D3E7FA;\n }\n\n body.light-theme {\n   --brandBodyBackgroundColor: #e5e5e5;\n   --brandInputBackgroundColor: #465970;\n   --brandSecondaryInputBackgroundColor: #465970;\n\n   --brandPrimaryColor: #4b7091;\n   --brandSecondaryColor: #2b3746;\n   --brandTertiaryColor: #b6b6b7;\n   --brandBorderActiveColor: #465d7a;\n\n   --brandPrimaryBackgroundColor: #e8ebf0;\n   --brandSecondaryBackgroundColor: #ffffff;\n   --brandTertiaryBackgroundColor: #1d242e;\n   --brandInverseBackgroundColor: #FFFFFF;\n   --brandQuaternaryBackgroundColor: #1D242E;\n   --brandQuinaryBackgroundColor: #93CBEF;\n   --brandSenaryBackgroundColor: #D3E7FA;\n\n   --brandTextPrimaryColor: #2b3746;\n   --brandTextSecondaryColor: #4d5866;\n   --brandTextTertiaryColor: #646b76;\n   --brandTextInverseColor: #ffffff;\n   --text-default-color: #4d5866;\n\n   --brandTextQuaternaryColor: #FFFFFF;\n   --brandTextQuinaryColor: #EBEFF2;\n   --brandDefaultQuinaryColor: #93CBEF;\n   --brandTextSenaryColor: #1D242E;\n   --brandTextSeptenaryColor: #93CBEF;\n   --brandDefaultQuaternaryColor: #465970;\n   --brandSenaryBackgroundColor: #D3E7FA;\n   --brandTextSeptenaryColor: #D3E7FA;\n   --brandDefaultSenaryColor: #93CBEF;\n\n\n   /* --brandGraphPrimaryColor:#2276c0; \n  --brandGraphSecondaryColor: #144380;\n  --brandGraphTertiaryColor: #002342;\n  --brandGraphQuaternaryColor: #385671;\n  --brandGraphQuinaryColor:#5c95c8; */\n\n   --brandBorderPrimaryColor: #c3cbd1;\n   --brandBorderActiveColor: #4B7091;\n   --brandBorderSecondaryBorderColor: #93CBFF;\n   --brandDisabledColor: #dbe2e9;\n   --brandErrorColor: #f44336;\n   --brandSuccessColor: #008858;\n   /* lightMode colors \n  --body-background: #e5e5e5;\n  --input-background: #465970;\n\n  --primary-color: #4b7091;\n  --secondary-color: #2b3746;\n  --secondary-color: #2b3746;\n\n  --background-primary-color: #e8ebf0;\n  --background-secondary-color: #ffffff;\n  --background-tertiary-color: #1d242e;\n  --background-inverse-color: #2b3746;\n  \n  --text-primary-color: #2b3746;\n  --text-secondary-color: #4d5866;\n  --text-tertiary-color: #646b76;\n  --text-inverse-color: #ffffff;\n  --text-default-color: #4d5866;\n\n  --graph-primary-color: #2276c0;\n  --graph-secondary-color: #144380;\n  --graph-tertiary-color: #002342;\n  --graph-quaternary-color: #385671;\n  --graph-quinary-color: #5c95c8;\n\n  --border-primary-color: #c3cbd1;\n  --border-active-color: #4B7091;\n  --branddisabled-color: #dbe2e9; */\n\n   /* --branderror-color: #f44336;\n  --brandsuccessful-color: #008858; */\n\n   --forest-green-color: #228b22;\n   --midnight-blue-color: #191970;\n   --mediumorchid--color: #ba55d3;\n   --ligh-mode--box-shadow-color: #0000000f;\n   --brandselected-list-box-color: #00000014;\n   --button-disable-color: #d3d3d3;\n   --shadow: rgba(0, 0, 0, .25);\n   --brandselected-file-color: #E8EBF0;\n\n\n\n   /* new colors */\n   /* background colors */\n   --brandPageBackgroundColor: #E8EBF0;\n   --brandInverseBackgroundColor: #FFFFFF;\n   --brandInformationBackgroundColor: #DBE2E9;\n   --brandField-selectionBackgroundColor: #E8EBF0;\n   --brandNavigationBackgroundColor: #2B3746;\n   --brandNavigationFieldSelectionBackgroundColor: #4B7091;\n\n   /* Text colors */\n   --brandPrimaryTextColor: #2B3746;\n   --brandSecondaryTextColor: #4D5866;\n   --brandButtonTextColor: #4B7091;\n   --brandInverseTextColor: #FFFFFF;\n   --brandNavigationTextColor: #FFFFFF;\n   --brandNavigationSelectionTextColor: #93CBEF;\n   --brandDisabledTextColor: #4D5866;\n   --brandCreditCardTextColor: #FFFFFF;\n   --brandSelectedPillTextColor: #FFFFFF;\n   --brandUnselectedPillTextColor: #4B7091;\n\n   /* Button colors */\n   --brandPrimaryButtonColor: #4B7091;\n   --brandTopPageButtonColor: #DBE2E9;\n\n   /* Pill colors */\n   --brandUnselectedPillColor: #FFFFFF;\n   --brandSelectedPillColor: #4B7091;\n\n   /* Border colors */\n   --brandPrimaryBorderColor: #C3CBD1;\n   --brandFieldBorderColor: #2B3746;\n   --brandActiveBorderColor: #4B7091;\n   --brandNavigationBorderColor: #AFBDD1;\n   --brandNavigationFieldBorderColor: #FFFFFF;\n   --brandUnselectedpPillBorderColor: #4B7091;\n\n   /* Icon colors */\n   --brandPrimaryIconColor: #4B7091;\n   --brandInverseIconColor: #FFFFFF;\n   --brandNavigationIconColor: #FFFFFF;\n   --brandNavigationSelectionIconColor: #93CBEF;\n   --brandNavigationFieldIconColor: #93CBEF;\n   --brandSelectedPillIconColor: #FFFFFF;\n   --brandUnselectedPillIconColor: #4B7091;\n\n   /* State colors */\n   --brandDefaultStateColor: #2B3746;\n   --brandErrorStateColor: #B31E14;\n   --brandSuccessStateColor: #008858;\n   --brandDisabledStateColor: #C3CBD1;\n   --brandHoverStateColor: #2B3746;\n\n   /* Graph colors */\n   --brandGraphPrimaryColor: #2276c0;\n   --brandGraphSecondaryColor: #144380;\n   --brandGraphTertiaryColor: #002342;\n   --brandGraphQuaternaryColor: #385671;\n   --brandGraphQuinaryColor: #5c95c8;\n   --brandGraphSenaryColor: #93CBEF;\n\n   /* Login page colors */\n   /* Background colors */\n   --brandLoginPageBackgroundColor: #1D242E;\n   --brandLoginFieldBackgroundColor: #465970;\n   --brandLoginFieldSelectionBackgroundColor: #2E3C50;\n\n   /* Text colors */\n   --brandLoginPrimaryTextColor: #FFFFFF;\n   --brandLoginFieldTextColor: #FFFFFF;\n   --brandLoginButtonTextColor: #1D242E;\n   --brandLoginFooterBarTextColor: #1D242E;\n\n   /* Button colors */\n   --brandLoginPrimaryButtonColor: #93CBEF;\n   --brandLoginHoverButtonColor: #D3E7FA;\n\n   /* Border colors */\n   --brandLoginFieldBorderColor: #EBEFF2;\n\n   /* Icon colors */\n   --brandLoginFieldIconColor: #FFFFFF;\n\n   /* State colors */\n   --brandLoginErrorStateColor: #FF738C;\n\n   /* Footer colors */\n   --brandLoginOutsideFooterBarColor: #93CBFF;\n   --brandLoginInsideFooterBarColor: #D3E7FA;\n\n }\n\n * {\n   margin: 0;\n   padding: 0;\n   box-sizing: border-box;\n   /* overflow: hidden; */\n   --webkit-overflow: hidden;\n }\n\n html,\n body {\n   font-size: 1em;\n   font-style: normal;\n  overflow-x: hidden;\n  overflow-y: auto;\n   \n }\n\n #root {\n   height: 100%;\n   opacity: 0;\n }\n\n #root.show {\n   transition: opacity .25s ease-in;\n   opacity: 1;\n }\n\n #page-loader {\n   position: absolute;\n   top: 0;\n   left: 0;\n   width: 100%;\n   height: 100%;\n   z-index: -1;\n }\n\n #page-loader.hide {\n   display: none;\n }\n\n #page-loader img {\n   position: absolute;\n   top: 50%;\n   left: 50%;\n   transform: translateX(-50%) translateY(-50%);\n\n }\n\n #page-loader>#page-loader-image.hide {\n   visibility: hidden;\n }\n\n /* =======================react date picker================== */\n\n .date-picked {\n   background: var(--text-inverse-color);\n   border: 2px solid var(--primary-color);\n   box-sizing: border-box;\n   border-radius: 6px;\n   width: 78%;\n   height: 40px;\n   z-index: 1;\n   position: absolute;\n   position: relative;\n   display: flex;\n   flex-direction: row;\n   justify-items: center;\n   justify-content: space-between;\n   align-items: center;\n   padding: 0px 4px 0px 4px;\n   margin-left: 0px !important;\n   margin-bottom: 6px;\n }\n\n .rdrDefinedRangesWrapper {\n   display: none !important;\n }\n\n .rdrDateDisplayWrapper {\n   width: 85%;\n }\n\n .rdrDateDisplayWrapper {\n   background-color: transparent !important;\n }\n\n .rdrMonths.rdrMonthsHorizontal {\n   border: 2px solid var(--primary-color) !important;\n   border-top: none !important;\n }\n\n .rdrMonthAndYearWrapper {\n   border: 2px solid var(--primary-color) !important;\n   border-bottom: none !important;\n }\n\n .DateRangePicker-container {\n   border-radius: 6px;\n }\n\n .rdrCalendarWrapper {\n   border-radius: 10px;\n }\n\n .rdrCalendarWrapper {\n   border-right: 8px;\n }\n\n .rdrStartEdge.rdrEndEdge {\n   background: var(--primary-color);\n   color: var(--input-background) !important;\n }\n\n .rdrDayToday .rdrDayNumber span:after,\n .rdrStartEdge,\n .rdrEndEdge {\n   background: var(--primary-color) !important;\n }\n\n .rdrDayEndPreview {\n   border: 2px solid var(--primary-color) !important;\n }\n\n .rdrStartEdge+.rdrDayNumber span,\n .rdrEndEdge+.rdrDayNumber span {\n   color: var(--text-inverse-color) !important;\n }\n\n .rdrInRange {\n   background: var(--background-primary-color) !important;\n }\n\n .rdrDayNumber span {\n   color: var(--secondary-color) !important;\n   font-weight: 600;\n   font-size: 12px;\n   line-height: 18px;\n }\n\n .rdrDayDisabled>.rdrDayNumber span {\n   color: var(--background-primary-color) !important;\n }\n\n .rdrWeekDay,\n .rdrMonthName {\n   font-weight: 600 !important;\n   font-size: 14px;\n   line-height: 18px;\n   text-align: center;\n   color: var(--primary-color) !important;\n }\n\n .rdrDayPassive {\n   visibility: hidden !important;\n }\n\n .submit-btn {\n   width: 82px;\n   height: 42px;\n   background: var(--primary-color);\n   border-radius: 2px;\n   border-style: none;\n   outline: none;\n   cursor: pointer;\n   font-family: 'Poppins', sans-serif;\n   font-style: normal;\n   font-weight: 600;\n   font-size: 14px;\n   line-height: 18px;\n   color: var(--text-inverse-color);\n }\n\n .submit-btn:hover {\n   background: var(--secondary-color);\n }\n\n .submit-btn:disabled {\n   background-color: var(--background-primary-color);\n   color: var(--border-primary-color);\n   cursor: not-allowed;\n }\n\n .react-pdf__Page__svg {\n   background-color: transparent !important;\n }\n\n .rdrDateDisplayItemActive,\n .rdrDateDisplayItem {\n   border-color: var(--primary-color) !important;\n   border-width: 2px !important;\n   height: 50px;\n   display: flex !important;\n   align-items: center !important;\n }\n\n .rdrDateDisplayItem input,\n .rdrDateDisplayItemActive input {\n   font-family: 'Poppins', sans-serif !important;\n   color: var(--text-default-color) !important;\n }\n\n .rdrDateDisplay {\n   margin-left: 0px !important;\n }\n\n .btn-container {\n   display: flex;\n   flex-direction: row;\n   justify-content: space-between;\n   position: absolute;\n   z-index: 2;\n   margin-left: 85%;\n   margin-top: 28px;\n }\n\n .main-container {\n   position: 'relative';\n }\n\n .DateRangePicker-container.error .rdrDateDisplayWrapper .rdrDateDisplay .rdrDateDisplayItem {\n   border: 2px solid var(--branderror-color) !important;\n }\n\n @media (max-width: 1430px) {\n\n   .main-container>.rdrDateRangePickerWrapper,\n   .main-container {\n     display: flex !important;\n     justify-content: center !important;\n     flex-direction: column !important;\n     align-items: center !important;\n   }\n\n   .btn-container {\n     position: unset;\n     margin-left: 0px;\n     margin-bottom: 14px;\n   }\n\n   .submit-btn {\n     width: 100%;\n     padding: 7px 150px;\n   }\n\n   .rdrMonths.rdrMonthsVertical {\n     border: 2px solid var(--primary-color) !important;\n     border-top: none !important;\n   }\n\n   .rdrDateDisplayWrapper {\n     width: 100%;\n   }\n\n   .calendar-labels-wrapper {\n     width: 80%;\n     display: flex;\n     gap: 7%;\n   }\n }\n\n .rdrMonthsVertical {\n   border: 2px solid var(--primary-color) !important;\n }\n\n .labels-container {\n   display: flex;\n   flex-direction: column;\n }\n\n .labels-container>p {\n   color: var(--brandLoginErrorStateColor);\n }\n\n .MuiPickersBasePicker-container .MuiPickersToolbar-toolbar,\n .MuiPickersCalendar-week .MuiPickersDay-daySelected,\n .MuiPickersCalendar-week .MuiPickersDay-daySelected:hover {\n   background-color: var(--brandPrimaryButtonColor);\n   font-family: 'Poppins', sans-serif;\n   color: var(--brandInverseTextColor);\n }\n\n .MuiPickersDay-daySelected .MuiTypography-body2,\n .MuiPickersCalendarHeader-daysHeader .MuiTypography-caption,\n .MuiPickersCalendarHeader-switchHeader .MuiPickersSlideTransition-transitionContainer .MuiTypography-body1, .MuiButtonBase-root {\n   font-family: 'Poppins', sans-serif;\n }\n\n .MuiButton-label .MuiPickersToolbarText-toolbarBtnSelected {\n   /* font-family: 'Poppins'; */\n   color: var(--brandPrimaryTextColor);\n }\n\n .calendar-labels-wrapper {\n   display: flex;\n   margin-bottom: -2px;\n }\n\n .calendar-labels {\n   width: 41%;\n   padding: 0 0 0 8px;\n   font-size: 0.8em;\n   font-weight: 400;\n   color: var(--brandPrimaryTextColor);\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
